export default __webpack_public_path__ + "static/img/promo-icon-1-active.d93178d.png";